let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eCyD4")).then(() => parcelRequire('5BR1H'));